module.exports = __webpack_public_path__ + "static/media/digmentha-mission.2e0a5676.svg";